import React from 'react';
import {
    Route as ReactDOMRoute,
    Redirect
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';

const Route = ({ isPrivate= false, component: Component, ...props }) => {
    const { user } = useAuth();

    return (
        <ReactDOMRoute
            {...props}
            render={({ location }) => {
                return isPrivate === !!user ? (
                    <Component />
                ) : (
                    <Redirect
                        to={
                            // Logou numa rota pública (login): volta para a página de onde
                            // veio (ex.: link da procuração recebido por e-mail).
                            !isPrivate && location.state?.from
                                ? location.state.from
                                : { pathname: isPrivate ? '/login' : '/', state: { from: location } }
                        }
                    />
                )
            }}
        />
    );
};

export default Route;
